import { FC, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Logo from "./Logo";
import MainMenu from "./MainMenu";
import UserInfoNav from "./userInfoNav/UserInfoNav";
import "./Header.scss";

const Header: FC = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Close the mobile drawer after navigating to a new route.
  useEffect(() => {
    setIsMenuOpen(false);
  }, [pathname]);

  return (
    <header
      className={`navbar navbar-primary header${
        isMenuOpen ? " header--menu-open" : ""
      }`}
      role="navigation"
    >
      <Logo />
      <button
        type="button"
        className="header__toggler"
        aria-label={t("Menu")}
        aria-expanded={isMenuOpen}
        aria-controls="header-nav"
        onClick={() => setIsMenuOpen((open) => !open)}
      >
        <span className="header__toggler-bar" />
        <span className="header__toggler-bar" />
        <span className="header__toggler-bar" />
      </button>
      <nav
        id="header-nav"
        className="collapse navbar-collapse header__nav"
        aria-label={t("Menu")}
      >
        <MainMenu />
        <UserInfoNav />
      </nav>
    </header>
  );
};

export default Header;
